import * as types from '../../types';

/** The white-background shop renders exist for these s3 band colors only. */
const S3_HERO_COLORS: string[] = [
  types.ColorOption.Blue,
  types.ColorOption.Gray,
  types.ColorOption.Pink,
  types.ColorOption.Yellow,
];

const DESCRIPTORS = ['1500w', '3000w'];

/**
 * The image the hardware-first page opens the Mini gallery with. The standalone pdps keep the
 * grey-ground photography, so these renders sit in their own directory rather than replacing
 * `mini-01-*` / `circle-*`.
 */
export const HARDWARE_FIRST_MINI_HERO: types.IImage = {
  type: 'image',
  url: '/product_images/hardware-first/mini.jpg',
  descriptors: DESCRIPTORS,
};

/** The s3 layflat for `variant`, or undefined for a color with no white-background render. */
export function hardwareFirstS3Hero(variant?: types.IVariant): types.IImage | undefined {
  const color = variant?.options.color;
  if (!color || !S3_HERO_COLORS.includes(color)) {
    return undefined;
  }
  return { type: 'image', url: `/product_images/hardware-first/s3-${color}.jpg`, descriptors: DESCRIPTORS };
}
